import request from '@/utils/request';
export const defaultCityData = {
  id: 0,
  enabled: true,
  stateId: undefined,
  countryId: undefined,
  name: '',
  country: {
    id: undefined
  },
  state: {
    id: undefined
  }
};
export const getCities = params => request({
  url: '/cities',
  method: 'get',
  params
});
export const getAllCities = params => request({
  url: '/cities',
  method: 'get',
  params
});
export const getCityById = id => request({
  url: `/cities/${id}`,
  method: 'get'
});
export const updateCity = (id, data) => request({
  url: `/cities/${id}`,
  method: 'patch',
  data
});
export const deleteCity = id => request({
  url: `/cities/${id}`,
  method: 'delete'
});
export const createCity = data => request({
  url: '/cities/',
  method: 'post',
  data
});